import {MatButtonModule} from '@angular/material/button';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatDialogModule} from '@angular/material/dialog';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ChangerTechnicienBottomSheetComponent} from './projets.component';
import {MatListModule} from '@angular/material/list';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatDividerModule} from '@angular/material/divider';

@NgModule({
  declarations: [
    ChangerTechnicienBottomSheetComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,

    MatListModule,
    MatDividerModule,
    MatBottomSheetModule,
    MatDialogModule,
    MatButtonModule
  ]
})
export class ProjetsModule {
}
